module.exports = __webpack_public_path__ + "img/city.2b78ecd0.png";